
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import TopHeader from "./top-header.vue";
import SideNav from "./side-nav.vue";
import t from "@common/src/i18n/t";
const user = namespace("user");
const app = namespace("app");
const common_app = namespace("common_app");
const base = namespace("base");
@Component({
  components: { TopHeader, SideNav }
})
export default class Layout extends Vue {
  @user.Getter isLogin;
  @base.Action getNewOrderMessage;
  @app.State pbpx;
  @base.Action queryAllInstructionConfig;
  @app.State orderPushState;
  @base.State showInstrctionIcon;
  @base.State instrctionUrl;
  @base.State showInstructionEntryTips;
  @base.Mutation setShowInstructionEntryTips;
  @common_app.State isViewAlive;
  isRouterAlive: boolean = true;
  mp3Annunciate: string = t("v212.there-are-new-orders-for-tmall");
  showInstructionEntry = false;

  created() {
    if (!this.isLogin) {
      this.$router.push("/login");
    }
    this.loopGetMsg();
    this.queryAllInstructionConfig({
      clientType: "STORE_PC"
    });
  }

  destroyed() {
    // 销毁定时器
    this.timerId && clearInterval(this.timerId);
  }
  playSpeek() {
    this.browserPlaySpeek();
    // (document.getElementById("audios") as any).play();
  }
  pushMessage(item) {
    this.createNotice(item);
    if (this.orderPushState) {
      this.playSpeek();
    }
  }
  openMsgIds: any[] = [];
  timerId: any = 0;
  loopGetMsg() {
    let query = () => {
      this.getNewOrderMessage().then(data => {
        if (data.data?.list && data.data.list.length > 0) {
          data.data.list.forEach((item, index) => {
            if (!this.openMsgIds.includes(item.messageId)) {
              setTimeout(() => {
                this.pushMessage(item);
                console.log("[ pushMessage ]");
              }, index * 1500);
            }
          });
        }
      });
    };
    setTimeout(query, 1000);
    this.timerId = setInterval(query, 30000);
  }
  clickNotify(orderNo) {
    let { href } = this.$router.resolve({
      path: `/service/view/${orderNo}`
    });
    window.open(href, "_blank");
  }
  createNotice({ orderNo, messageId, channelIcon, msgText, voiceText }) {
    this.openMsgIds.push(messageId);
    this.mp3Annunciate = voiceText;
    this.$notify({
      title: "",
      customClass: "__global-message-notify",
      dangerouslyUseHTMLString: true,
      message: `<div class='disflex'>
      <div class='margin-right-8'><img class='width-24' src='${channelIcon}'></div>
       <div>
       <p class='title notify-p1'>${orderNo}</p>
       <p class='color-gray2 notify-p2'>${msgText}</p></div>
       </div>`,
      duration: 0,
      position: "bottom-right",
      onClick: () => this.clickNotify(orderNo)
    });
  }
  handleToInstrction() {
    window.open(this.instrctionUrl);
  }
  handleISee() {
    this.showInstructionEntry = false;
    this.setShowInstructionEntryTips(false);
  }
  @Watch("showInstrctionIcon", { immediate: true })
  showInstrctionIconChange(val) {
    if (val && this.showInstructionEntryTips) {
      setTimeout(() => {
        this.showInstructionEntry = true;
      }, 1000);
    } else {
      this.showInstructionEntry = false;
    }
  }

  browserPlaySpeek(text = "天猫来新订单了") {
    // 创建SpeechSynthesisUtterance对象
    var utterance = new SpeechSynthesisUtterance(text);
    // 播放文本语音
    window.speechSynthesis.speak(utterance);
  }
}
